import React from 'react';
import ReactDOM from 'react-dom';

// render components in sma.admin
export default function render(Component, container, props) {
	ReactDOM.render(<Component {...props} container={container} />, container);
}
